import React from 'react';
import { Link } from 'react-router-dom';
import Header from "../layout/Header";
import Footer from '../layout/Footer';
import Toolbar from '../navigation/Toobar';
import Chat from '../components/common/Chat';
import useSEO from '../hooks/useSEO';
import { buildBreadcrumbJsonLd, getSiteBrand } from '../utils/seo';

const ABOUT_BREADCRUMBS = [
  { name: 'Home', path: '/' },
  { name: 'About Us', path: '/about-us' },
];

function AboutUs({ globalData }) {
  const brandName = globalData?.general?.site_title || getSiteBrand();

  useSEO({
    title: 'About Us – Games, Payments and Support',
    description: `Learn about ${brandName}: the sports and casino games we offer, BDT payments through bKash, Nagad and Rocket, the security practices we follow and the team behind our 24/7 support.`,
    keywords: `about ${brandName}, online gaming platform bangladesh, betting company bangladesh, bKash Nagad Rocket payments, responsible gaming`,
    path: '/about-us',
    brand: brandName,
    jsonLd: [buildBreadcrumbJsonLd(ABOUT_BREADCRUMBS)],
  });

  return (
    <div className="v-application--wrap">
      <div>
        <div className="row no-gutters">
          <Header />
        </div>

        <div className="body">
          <div className="page-container v-card v-sheet theme--dark">
            <div className="row">
              <div className="col col-12">
                <div className="pa-4">
                  <nav className="seo-breadcrumb" aria-label="Breadcrumb">
                    <Link to="/">Home</Link> <span aria-hidden="true">›</span>{' '}
                    <span aria-current="page">About Us</span>
                  </nav>

                  <h1 className="seo-h1">About {brandName}</h1>
                  <div className="mt-3">
                    <p className="seo-text">
                      {brandName} is an online sports betting and casino platform built for players
                      in Bangladesh. We focus on a smooth entertainment experience: quick
                      navigation, stable performance and a clean mobile-first design that works on
                      the phones and connections most players actually use.
                    </p>
                    <p className="seo-text">
                      Inside the platform you will find multiple game categories, promotions and
                      account tools — deposit, withdrawal and transaction history — all organised
                      so they are easy to reach when you need them.
                    </p>

                    <h2 className="seo-h2">What we offer</h2>
                    <ul className="seo-list">
                      <li>
                        <strong>Sportsbook:</strong> cricket, football and other sports with
                        pre-match and live in-play markets.
                      </li>
                      <li>
                        <strong>Live casino:</strong> real dealer tables including Teen Patti, Andar
                        Bahar, Roulette, Baccarat, Blackjack and Dragon Tiger.
                      </li>
                      <li>
                        <strong>Slots and arcade games:</strong> hundreds of titles from
                        international providers, plus crash, fishing and instant win games.
                      </li>
                      <li>
                        <strong>Payments in BDT:</strong> bKash, Nagad, Rocket, Upay, OK Wallet,
                        SureCash, Tap, bank transfer and cryptocurrency where available.
                      </li>
                      <li>
                        <strong>Promotions:</strong> welcome offers, rebates, referral rewards and
                        loyalty/VIP benefits, each with clearly stated rules.
                      </li>
                    </ul>

                    <h2 className="seo-h2">What we focus on</h2>
                    <div className="mt-2">
                      <ul className="mb-0">
                        <li>
                          <strong>Ease of use:</strong> simple menus and fast page loads.
                        </li>
                        <li>
                          <strong>Account safety:</strong> we may use verification and monitoring to
                          protect users and reduce fraud.
                        </li>
                        <li>
                          <strong>Payment support:</strong> multiple payment channels depending on
                          your region and configuration.
                        </li>
                        <li>
                          <strong>Responsible gaming:</strong> encouraging healthy play and control,
                          with support available if gambling stops being fun.
                        </li>
                      </ul>
                    </div>

                    <h2 className="seo-h2">Fair use</h2>
                    <p className="seo-text">
                      We aim to keep the platform fair for everyone. Activity that looks like abuse,
                      bonus exploitation or automated behaviour may lead to restrictions or an
                      account review. One account per player applies, and the full rules are listed
                      in our terms and conditions.
                    </p>

                    <h2 className="seo-h2">Support</h2>
                    <p className="seo-text">
                      If you need help, use our in-app chat or the official channels shown in the
                      footer, or write to us through the contact page. Sharing your username and a
                      short description of the issue helps us resolve problems faster — and we will
                      never ask for your password.
                    </p>
                    <p className="seo-text">
                      New here? Read our{' '}
                      <Link to="/faq">frequently asked questions</Link>, check the{' '}
                      <Link to="/promotion">latest promotions</Link> or{' '}
                      <Link to="/signup">create an account</Link> to get started.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <Footer sociallink={globalData?.socialLinks || {}} />
          </div>

          <Toolbar />
          <Chat />
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
